import CryptoJS from "crypto-js";

// ENCRYPTION FUNCTION 
export const encryptData = (payload) => {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    process.env.REACT_APP_SECRET_KEY
  ).toString();
  return {encryptedData: encryptedData};
};

// DECRYPTION FUNCTION
export const decryptData = (response) => {
  try {
    const bytes = CryptoJS.AES.decrypt(response, process.env.REACT_APP_SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  }
  catch (error) {
    console.error("Dycrypt error--->", error)
    return null;
  }
};